import { PartyPage } from "@/pages/Clients";
export default function Suppliers() { return <PartyPage kind="supplier" title="Supplier" subtitle="Daftar pemasok / vendor bisnis Anda." />; }
